import type { LucideIcon } from '@/components/icons'
import { cn } from '../utils/cn'

interface NavigationItemProps {
  id: string
  label: string
  icon: LucideIcon
  isActive: boolean
  onClick: (id: string) => void
  variant?: 'desktop' | 'mobile'
}

export function NavigationItem({
  id,
  label,
  icon: Icon,
  isActive,
  onClick,
  variant = 'desktop'
}: NavigationItemProps) {
  if (variant === 'mobile') {
    return (
      <button
        onClick={() => onClick(id)}
        className={cn(
          'flex flex-col items-center gap-1 py-2 rounded-lg transition-all duration-300 flex-1',
          isActive ? 'text-pastel-purple' : 'text-gray-500'
        )}
      >
        <Icon
          className={cn(
            'w-6 h-6 transition-all duration-300',
            isActive && 'scale-110'
          )}
        />
        <span className="text-xs font-fairy">{label}</span>
      </button>
    )
  }

  return (
    <button
      onClick={() => onClick(id)}
      className={cn(
        'flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-300',
        isActive
          ? 'bg-pastel-purple text-white'
          : 'text-gray-600 hover:bg-pastel-purple/20'
      )}
    >
      <Icon className="w-4 h-4" />
      <span className="font-fairy">{label}</span>
    </button>
  )
}
